var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { EngineService } from './engine.service';
import { Observable, of, concat } from 'rxjs';
import { Store } from '@ngxs/store';
import { ToggleLabels } from './state/engine.actions';
import { ImageService } from '../shared/image.service';
import { flatMap, map, combineAll, catchError } from 'rxjs/operators';
import { LabelsService } from '../story/labels.service';
import * as i0 from "@angular/core";
import * as i1 from "./engine.service";
import * as i2 from "../shared/image.service";
import * as i3 from "../story/labels.service";
import * as i4 from "@ngxs/store";
var SnapshotService = /** @class */ (function () {
    function SnapshotService(engineService, imageService, labelsService, store) {
        this.engineService = engineService;
        this.imageService = imageService;
        this.labelsService = labelsService;
        this.store = store;
    }
    SnapshotService.prototype.localResize = function (width, height) {
        /*
        Set the size of the container with css
        Set the size of the canvas drawingbuffers via canvas width/height properties
        */
        var engineCanvas = Human.renderer.canvas.canvas;
        var annotationCanvas = Human.renderer.canvas.annotationCanvas;
        var container = engineCanvas.parentNode;
        // original dimensions (container == 3D canvas == 2D canvas)
        var originalWidth = container.clientWidth;
        var originalHeight = container.clientHeight;
        // set width on container and canvas
        container.width = width;
        container.height = height;
        engineCanvas.width = width;
        engineCanvas.height = height;
        annotationCanvas.width = width;
        annotationCanvas.height = height;
        // style the container to match the element dimensions
        container.style.width = width + "px";
        container.style.height = height + "px";
        // Update the viewport
        Human.renderer.canvas.init(); // or HACK set engine's canvas.width/height manually
        Human.renderer.viewportDirty = true;
        Human.renderer.camera.updateCanvas();
        Human.renderer.postprocess.updateCanvas();
        Human.renderer.draw.updateCanvas();
        Human.renderer.viewportDirty = true;
        Human.renderer.prepareFrame();
        Human.renderer.forceRenderFrame();
        return [originalWidth, originalHeight];
    };
    // snapshot when requested dimension fits inside of 3D canvas
    SnapshotService.prototype.drawHumanCanvasToThumbnail = function (thumbnailCanvas) {
        // calculate source width and height dimensions
        var thumbanilAspect = thumbnailCanvas.width / thumbnailCanvas.height;
        var humanCanvas = this.engineService.getCanvas();
        var sourceHeight = humanCanvas.height;
        var sourceWidth = thumbanilAspect * sourceHeight;
        // calculate source offset
        var offsetX = 0.5 * (humanCanvas.width - sourceWidth);
        // render 3D frame and transfer to thumbnail canvas
        return new Observable(function (observer) {
            var thumbnailContext = thumbnailCanvas.getContext('2d');
            Human.renderer.forceRenderFrame();
            thumbnailContext.drawImage(humanCanvas, offsetX, 0, sourceWidth, sourceHeight, 0, 0, thumbnailCanvas.width, thumbnailCanvas.height);
            observer.next();
            observer.complete();
        });
    };
    // snapshot when requested dimension does NOT fit inside of 3D canvas (avoid pixelation)
    SnapshotService.prototype.drawResizeHumanCanvasToThumbnail = function (thumbnailCanvas) {
        var _this = this;
        var humanCanvas = this.engineService.getCanvas();
        humanCanvas.style.opacity = '0'; // hide while we do our resizing business. start of flash
        this.store.dispatch(new ToggleLabels(false));
        // resize 3D canvas
        var _a = __read(this.localResize(thumbnailCanvas.width, thumbnailCanvas.height), 2), originalWidth = _a[0], originalHeight = _a[1];
        var thumbnailContext = thumbnailCanvas.getContext('2d');
        return new Observable(function (observer) {
            setTimeout(function () {
                // force webgl render frame
                Human.renderer.viewportDirty = true;
                Human.renderer.prepareFrame();
                Human.renderer.forceRenderFrame();
                // draw webgl canvas to 2d canvas image
                thumbnailContext.drawImage(humanCanvas, 0, 0, humanCanvas.width, humanCanvas.height);
                // return the original size
                _this.localResize(originalWidth, originalHeight);
                document.getElementById('theCanvas').style.opacity = '';
                _this.store.dispatch(new ToggleLabels(true));
                observer.next();
                observer.complete();
            }, 10);
        });
    };
    SnapshotService.prototype.drawRadialGradient = function (thumbnailCanvas, background) {
        // convert to RGB colors
        var colors255 = background.colors;
        // convert stop percentages into radius values on the canvas
        var toRadius = function (percentage, width, height) {
            var _a = __read([Math.pow(width / 2, 2), Math.pow(height / 2, 2)], 2), x2 = _a[0], y2 = _a[1];
            return percentage / 100 * Math.pow(x2 + y2, 0.5);
        };
        var _a = __read(background.colorStops.map(function (s) { return toRadius(s, thumbnailCanvas.width, thumbnailCanvas.height); }), 2), radiusInner = _a[0], radiusOuter = _a[1];
        // create gradient, fillstyle
        var thumbnailContext = thumbnailCanvas.getContext('2d');
        var _b = __read([thumbnailCanvas.width / 2, thumbnailCanvas.height / 2], 2), x0 = _b[0], y0 = _b[1];
        var gradient = thumbnailContext.createRadialGradient(x0, y0, radiusInner, x0, y0, radiusOuter);
        gradient.addColorStop(background.colorStops[0] / 100.0, "rgba(" + colors255.slice(0, 4).join(',') + ")");
        gradient.addColorStop(background.colorStops[1] / 100.0, "rgba(" + colors255.slice(4, 8).join(',') + ")");
        // draw gradient
        thumbnailContext.fillStyle = gradient;
        thumbnailContext.fillRect(0, 0, thumbnailCanvas.width, thumbnailCanvas.height);
    };
    SnapshotService.prototype.drawLinearGradient = function (thumbnailCanvas, background) {
        // convert to RGB colors
        var colors255 = background.colors;
        // create gradient, fillstyle
        var thumbnailContext = thumbnailCanvas.getContext('2d');
        var _a = __read([thumbnailCanvas.width / 2, thumbnailCanvas.height / 2], 2), x0 = _a[0], y0 = _a[1];
        var gradient = thumbnailContext.createLinearGradient(x0, y0, x0, thumbnailCanvas.height);
        gradient.addColorStop(background.colorStops[0] / 100.0, "rgba(" + colors255.slice(0, 4).join(',') + ")");
        gradient.addColorStop(background.colorStops[1] / 100.0, "rgba(" + colors255.slice(4, 8).join(',') + ")");
        // draw gradient
        thumbnailContext.fillStyle = gradient;
        thumbnailContext.fillRect(0, 0, thumbnailCanvas.width, thumbnailCanvas.height);
    };
    // takeSnapshot of canvas return an observable
    SnapshotService.prototype.takeSnapshot = function (width, height, background, includeLabels, snapshotConfig) {
        /*
        Create 2D canvas to serve as the thumbnail
        Copy background data to thumbnail canvas
        Copy 3D canvas to thumbnail canvas
        */
        var _this = this;
        // config
        var imageType = snapshotConfig.imageType, imageQuality = snapshotConfig.imageQuality, copyrightEnabled = snapshotConfig.copyrightEnabled;
        // Create 2D canvas on which to draw 3D context
        var thumbnailCanvas = document.createElement('canvas');
        thumbnailCanvas.width = width;
        thumbnailCanvas.height = height;
        // Draw Background onto thumbnail canvas
        if (background.gradientType === 'radial') {
            this.drawRadialGradient(thumbnailCanvas, background);
        }
        else if (background.gradientType === 'linear') {
            this.drawLinearGradient(thumbnailCanvas, background);
        }
        var engineCanvas = this.engineService.getCanvas();
        var canvasResize = thumbnailCanvas.height > engineCanvas.height || thumbnailCanvas.width > engineCanvas.width;
        // composite a list of canvas elements to single image
        var canvases$ = [];
        // Draw 3D canvas
        var drawScene$ = (canvasResize ? this.drawResizeHumanCanvasToThumbnail(thumbnailCanvas) : this.drawHumanCanvasToThumbnail(thumbnailCanvas))
            .pipe(map(function () { return thumbnailCanvas; }));
        canvases$.push(drawScene$);
        // Draw labels: optional
        var labelContainer = this.labelsService.getLabelContainer();
        if (includeLabels && labelContainer) {
            var labelCanvas$ = this.imageService.elementToCanvas(labelContainer.nativeElement, true) // render labels
                .pipe(flatMap(function (elementCanvas) { return _this.imageService.fitCanvas(elementCanvas, { width: width, height: height }); }) // scale to target
            );
            canvases$.push(labelCanvas$);
        }
        // sequentially render + composite canvas elements
        return concat(canvases$)
            .pipe(
        // gather canvas elements
        combineAll(), 
        // merge canvas elements
        map(function (canvases) { return _this.imageService.combineCanvasElements(canvases); }), 
        // add logo: optional
        flatMap(function (canvas) { return copyrightEnabled ? _this.writeLogoToCanvas(canvas, snapshotConfig) : of(canvas); }), 
        // to data blob
        flatMap(function (compositeCanvas) { return _this.imageService.canvasToBlob(compositeCanvas, imageType, imageQuality); }));
    };
    SnapshotService.prototype.writeLogoToCanvas = function (canvas, config) {
        var _this = this;
        return this.getLogoImage(config.copyrightImagePath) // get logo
            .pipe(
        // write image to canvas
        map(function (image) {
            // calculate position
            var _a = _this.getLogoPosition(canvas.width, canvas.height, image.width, image.height, config), xOffset = _a.xOffset, yOffset = _a.yOffset;
            // write image
            var canvasContext = canvas.getContext('2d');
            canvasContext.drawImage(image, xOffset, yOffset);
            return canvas;
        }), 
        // handle errors
        catchError(function () { return of(canvas); }));
    };
    SnapshotService.prototype.getLogoImage = function (path) {
        return new Observable(function (observer) {
            var image = new Image();
            image.onload = function () {
                observer.next(image);
                observer.complete();
            };
            image.onerror = function () { return observer.error(); };
            image.src = path;
        });
    };
    SnapshotService.prototype.getLogoPosition = function (viewWidth, viewHeight, imageWidth, imageHeight, config) {
        var copyrightPosition = config.copyrightPosition, copyrightOffset = config.copyrightOffset;
        var xPosition;
        var yPosition;
        // Calc X
        switch (copyrightPosition.x) {
            case 'right':
                xPosition = viewWidth - imageWidth;
                break;
            case 'center':
                xPosition = (viewWidth / 2) - (imageWidth / 2);
                break;
            default:
                xPosition = 0;
                break;
        }
        // Calc Y
        switch (copyrightPosition.y) {
            case 'bottom':
                yPosition = viewHeight - imageHeight;
                break;
            case 'center':
                yPosition = (viewHeight / 2) - (imageHeight / 2);
                break;
            default:
                yPosition = 0;
                break;
        }
        // offset w/ config
        return {
            xOffset: xPosition + copyrightOffset.x,
            yOffset: yPosition + copyrightOffset.y
        };
    };
    SnapshotService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SnapshotService_Factory() { return new SnapshotService(i0.ɵɵinject(i1.EngineService), i0.ɵɵinject(i2.ImageService), i0.ɵɵinject(i3.LabelsService), i0.ɵɵinject(i4.Store)); }, token: SnapshotService, providedIn: "root" });
    return SnapshotService;
}());
export { SnapshotService };
